export default {
  UPDATING: 'ADMIN_VIEW_VARIABLES_EDITOR_UPDATING',
  UPDATED: 'ADMIN_VIEW_VARIABLES_EDITOR_UPDATED',
};
